import { updateRemote } from '../atomic';
import ENTITIES from '..';

export function editAgent(store, data) {
  updateRemote(store, ENTITIES.AGENT, data);
}
